import { createDecorator } from '../../../../platform/instantiation/common/instantiation.js';
const ILanguageDetectionService = ( createDecorator('ILanguageDetectionService'));
export { ILanguageDetectionService };
